import imagesLoaded from 'imagesloaded';
import { lightbox } from '@/scripts/utilities/lightbox';

type Elements = {
  images: HTMLImageElement[];
  choices: HTMLDivElement[];
};

type Enlarge = {
  elements: Elements;
  columnWidth: number;
  init: () => void;
  handleImage: (image: HTMLImageElement) => void;
  handleChoice: (choice: HTMLDivElement) => void;
};

const enlarge: Enlarge = {
  elements: {
    images: [],
    choices: [],
  },

  columnWidth: 242,

  init() {
    this.elements.images = Array.from(document.querySelectorAll('.question__row:not(.question__row--multiple_choice) img'));
    this.elements.choices = Array.from(document.querySelectorAll('.question__row--multiple_choice'));

    imagesLoaded(document.body, () => {
      if (this.elements.images.length) {
        this.elements.images.forEach((image) => this.handleImage(image));
      }

      if (this.elements.choices.length) {
        this.elements.choices.forEach((choice) => this.handleChoice(choice));
      }
    });
  },

  handleImage(image: HTMLImageElement) {
    if (!image || this.columnWidth > image.width) return;

    const wrapper = document.createElement('div');
    const button = `<div class="image-enlarge__button"><a href="" class="button button--primary" data-target="question-enlarge" data-image="${image.src}" data-alt="${image.alt}"><i></i> Enlarge</a></div>`;

    image?.parentNode?.insertBefore(wrapper, image);
    wrapper.appendChild(image);
    wrapper.innerHTML = `<div class="image-enlarge__content"><div class="image-enlarge__inner">${wrapper.innerHTML}</div></div>${button}`;
    const buttonElement = wrapper.querySelector('.button--primary');

    // Fix: bind the event handler properly
    if (buttonElement) {
      buttonElement.addEventListener('click', (e) => {
        lightbox.handleOpen(e, buttonElement as HTMLElement);
      });
    }

    wrapper.classList.add('image-enlarge__wrapper');
  },

  handleChoice(choice: HTMLDivElement) {
    if (!choice) return;

    const images = Array.from(choice.querySelectorAll('img'));

    if (images.length) {
      const allowEnlarge = images.filter((image) => this.columnWidth < image.width);

      if (allowEnlarge.length) {
        const html = choice.innerHTML;
        const wrapper = document.createElement('div');
        const button = `<div class="image-enlarge__button"><a href="" class="button button--primary" data-target="question-enlarge" data-html="${encodeURIComponent(html)}"><i></i> Enlarge</a></div>`;

        choice.parentNode?.insertBefore(wrapper, choice);
        wrapper.appendChild(choice);
        wrapper.innerHTML = `<div class="image-enlarge__content"><div class="image-enlarge__inner">${wrapper.innerHTML}</div></div>${button}`;
        const buttonElement = wrapper.querySelector('.button--primary');

        if (buttonElement) {
          buttonElement.addEventListener('click', (e) => {
            lightbox.handleOpen(e, buttonElement as HTMLElement);
          });
        }

        wrapper.classList.add('image-enlarge__wrapper');
      }
    }
  },
};

export default enlarge;
